<ccl-page-header>
    <div class="s-page-header__left c-page-header__left">
        <div class="c-title c-title--secondary">
            Recommendation - Event Advisor Widget
        </div>
    </div>
    <div class="s-page-header__right">
        <ccl-toggle-button
            [title]="sessionWidgetConfig.isWidgetEnabled ? 'Enable' : 'Disable'"
            [isChecked]="sessionWidgetConfig.isWidgetEnabled"
            (isCheckedChange)="toggleWidgetEnabled($event)"
            >{{ sessionWidgetConfig.isWidgetEnabled ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</ccl-page-header>

<ccl-content-section *ngIf="sessionWidgetConfig.isWidgetEnabled == true">
    <div class="widgets-drawer" *ngIf="widgets == null || widgets.length == 0">
        <div class="row row--builder">
            <div class="col c-box" >
                <div>
                    <h5 class="no-data">Event Advisor Widget data not available.</h5>
                </div>
            </div>
        </div>
    </div>

    <!-- Display when widgets data available for respected event -->
    <div class="widgets-drawer" *ngIf="widgets.length > 0">
        <!-- Session Advisor widget select ui item -->
        <div class="c-title--subsection text-uppercase">
            Widget
        </div>
        <div class="row row--builder">
            <div class="col col--builder">
                <div class="c-box">
                    <div class="c-form-group">
                        <ccl-simple-select ariaLabel="Header Page Advisor Widgets Link"
                            [listOfItems]="widgets"
                            (valueChange)="changeWidgets($event.value); sessionWidgetConfig.widget.uuid = $event.value"
                            [value]="sessionWidgetConfig.widget.uuid"
                            [bindValue]="'uuid'"
                            [bindLabel]="'name'"
                        ></ccl-simple-select>
                        <div class="c-form-group__hint">&nbsp;</div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>

        <!-- Widget placement section with position on catalog's Header and HTML section -->
        <div class="d-flex justify-content-between align-items-center">
            <div class="c-title--subsection text-uppercase">
                Widget Placement
            </div>
        </div>
        <div class="row row--builder">
            <div class="col col--builder">
                <div class="c-box row" title="Show Widget Placement data and options">
                    <div class="col-sm-6">
                        <!-- Displaying widget placement section on admin UI -->
                        <header class="d-flex  border-bottom text-colors justify-content-between align-items-center">
                            <div class="c-title c-title--subsection pb9">
                                Placement Section:
                            </div>
                        </header>
                        <div class="row layout-builder">
                            <p class="pl15 col-sm-6" (cclClick)="loadWidgetPlacementComponents('header', true); sessionWidgetConfig.widget.widgetPlacement = 'header'">
                                <ccl-radio-button
                                    buttonStyle="c-radiobutton"
                                    [name]="'widgetPlacement'"
                                    [id]="'widgetPlacementHeader'"
                                    [value]="'header'"
                                    [model]="sessionWidgetConfig.widget.widgetPlacement"
                                    >Header
                                </ccl-radio-button>
                                <img
                                    alt="Header widget Placement"
                                    [src]="
                                    sessionWidgetConfig.widget.widgetPlacement == 'header'
                                            ? 'assets/images/layout-page/nav/widget_placement_header_on.png'
                                            : 'assets/images/layout-page/nav/widget_placement_off.png'
                                    "
                                    class="img-height"
                                />
                            </p>
                            <p class="col-sm-6" (cclClick)="loadWidgetPlacementComponents('html', true); sessionWidgetConfig.widget.widgetPlacement = 'html'">
                                <ccl-radio-button
                                    buttonStyle="c-radiobutton"
                                    [name]="'widgetPlacement'"
                                    [id]="'widgetPlacementHtml'"
                                    [value]="'html'"
                                    [model]="sessionWidgetConfig.widget.widgetPlacement"
                                    >Header HTML
                                </ccl-radio-button>
                                <img
                                    alt="HTML Widget Placement"
                                    [src]="
                                    (sessionWidgetConfig.widget.widgetPlacement == null || 
                                    sessionWidgetConfig.widget.widgetPlacement == 'html')
                                            ? 'assets/images/layout-page/nav/widget_placement_html_on.png'
                                            : 'assets/images/layout-page/nav/widget_placement_off.png'
                                    "
                                    class="img-height"
                                />
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <!-- Displaying Position within placement section on admin UI -->
                        <header class="d-flex border-bottom text-colors justify-content-between align-items-center">
                            <div class="c-title c-title--subsection pb9">
                                Position Within Section:
                            </div>
                        </header>
                        <div class="layout-builder">
                            <!-- Only TOP position section -->
                            <p (cclClick)="manageWidgetPlacementPosition('top')">
                                <ccl-radio-button
                                    buttonStyle="c-radiobutton"
                                    [name]="'widgetPlacementPosition'"
                                    [id]="'widgetPlacementPositionTop'"
                                    [value]="'top'"
                                    [model]="sessionWidgetConfig.widget.widgetPlacementPosition"
                                    >Top
                                </ccl-radio-button>
                            </p>

                            <!-- Only BOTTOM position section -->
                            <p (cclClick)="manageWidgetPlacementPosition('bottom')">
                                <ccl-radio-button
                                    buttonStyle="c-radiobutton"
                                    [name]="'widgetPlacementPosition'"
                                    [id]="'widgetPlacementPositionBottom'"
                                    [value]="'bottom'"
                                    [model]="sessionWidgetConfig.widget.widgetPlacementPosition"
                                    >Bottom
                                </ccl-radio-button>
                            </p>

                            <!-- From TOP position section -->
                            <div class="row layout-builder" [class.disabled-div]="!widetPlacementComponents.length > 0" [hidden]="!widetPlacementComponents.length > 0">
                                <p (cclClick)="manageWidgetPlacementPosition('nth_component')">
                                    <ccl-radio-button
                                        buttonStyle="c-radiobutton"
                                        [name]="'widgetPlacementPosition'"
                                        [id]="'widgetPlacementPositionnth_component'"
                                        [value]="'nth_component'"
                                        [model]="sessionWidgetConfig.widget.widgetPlacementPosition"
                                        ></ccl-radio-button>
                                </p>
                                <div id="placementComponentTop" class="c-form-group col-sm-3 no-padding" [class.disabled-div]="sessionWidgetConfig.widget.widgetPlacementPosition != 'nth_component'">
                                    <ccl-simple-select ariaLabel="Nth Position from Top within section"
                                        [listOfItems]="widetPlacementComponents"
                                        (valueChange)="sessionWidgetConfig.widget.widgetPlacementComponentPosition.top = $event.value"
                                        [value]="sessionWidgetConfig.widget.widgetPlacementComponentPosition.top"
                                        [bindValue]="'id'"
                                        [bindLabel]="'label'">
                                    </ccl-simple-select>
                                    <div class="c-form-group__hint">&nbsp;</div>
                                </div>
                                <label class="pl5" (cclClick)="manageWidgetPlacementPosition('nth_component')">From Top</label>
                            </div>

                            <!-- From BOTTOM position section -->
                            <div class="row layout-builder" [class.disabled-div]="!widetPlacementComponents.length > 0" [hidden]="!widetPlacementComponents.length > 0">
                                <p (cclClick)="manageWidgetPlacementPosition('nth_component_bottom')">
                                    <ccl-radio-button
                                        buttonStyle="c-radiobutton"
                                        [name]="'widgetPlacementPosition'"
                                        [id]="'widgetPlacementPositionnth_component_bottom'"
                                        [value]="'nth_component_bottom'"
                                        [model]="sessionWidgetConfig.widget.widgetPlacementPosition"
                                        ></ccl-radio-button>
                                </p>
                                <div id="placementComponentBottom" class="c-form-group col-sm-3 no-padding" [class.disabled-div]="sessionWidgetConfig.widget.widgetPlacementPosition != 'nth_component_bottom'">
                                    <ccl-simple-select ariaLabel="Nth Position from Bottom within section"
                                        [listOfItems]="widetPlacementComponents"
                                        (valueChange)="sessionWidgetConfig.widget.widgetPlacementComponentPosition.bottom = $event.value"
                                        [value]="sessionWidgetConfig.widget.widgetPlacementComponentPosition.bottom"
                                        [bindValue]="'id'"
                                        [bindLabel]="'label'">
                                    </ccl-simple-select>
                                    <div class="c-form-group__hint">&nbsp;</div>
                                </div>
                                <label class="pl5" (cclClick)="manageWidgetPlacementPosition('nth_component_bottom')">From Bottom</label>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>

        <!-- Widget preview section with configuration change drawer action item -->
        <div class="d-flex justify-content-between align-items-center">
            <div class="c-title--subsection text-uppercase">
                Widget Preview
            </div>
            <div *ngIf="sessionWidgetConfig.widget.uuid != null && sessionWidgetConfig.widget.uuid != '' && sessionWidgetConfig.widget.uuid != 'undefined' && sessionWidgetConfig.widget.widgetConfiguration != undefined && sessionWidgetConfig.widget.widgetConfiguration.color != null && !sessionWidgetConfig.widget.widgetConfiguration.theme" class="pr5">
                <button class="c-btn c-btn--primary config-btn" (cclClick)="openConfigDrawer('configuration', $event, 'body')">
                    Theme Configuration
                </button>
            </div>
        </div>
        <div class="row row--builder">
            <div class="col col--builder">
                <!-- <div class="c-box flex-between"
                    title="Apply catalog widget configuration"
                    (mouseout)="hoverOut = false"
                    (mouseover)="hoverOut = true"
                    *ngIf="sessionWidgetConfig.widget.uuid != null && sessionWidgetConfig.widget.uuid != '' && sessionWidgetConfig.widget.uuid != 'undefined'">
                    <div class="s-page-header__left c-page-header__left">
                        <div class="c-title">
                            Apply Catalog Configuration
                        </div>
                    </div>
                    <div class="s-page-header__right">
                        <ccl-toggle-button
                            [title]="sessionWidgetConfig.widget.applyCatalogConfiguration ? 'Enable' : 'Disable'"
                            [isChecked]="sessionWidgetConfig.widget.applyCatalogConfiguration"
                            (isCheckedChange)="toggleApplyCatalogWidgetConfiguration($event)">
                                {{ sessionWidgetConfig.widget.applyCatalogConfiguration ? "Enabled" : "Disabled" }}
                            </ccl-toggle-button>
                    </div>
                </div> -->
                <div class="c-box" title="Show Widget preview data" [ngClass]="{
                    'overflow-auto' : isWidgetScrollable,
                    'overflow-hidden' : !isWidgetScrollable
                }">
                    <div *ngIf="sessionWidgetConfig.widget.uuid == null || sessionWidgetConfig.widget.uuid == '' || sessionWidgetConfig.widget.uuid == 'undefined'">
                        <h5 class="no-data">No Widget preview data available</h5>
                    </div>
                    <!-- Add Widget preview container div to load preview of widget -->
                    <div *ngIf="sessionWidgetConfig.widget.uuid != null && sessionWidgetConfig.widget.uuid != '' && sessionWidgetConfig.widget.uuid != 'undefined'">
                        <header class="d-flex  border-bottom text-colors justify-content-between align-items-center">
                            <div class="c-title c-title--subsection pb9">
                                Preview: {{ selectedWidget.name }}
                            </div>
                        </header>
                        <!-- <div id="widgetPreview">
                            <div id="widgetPreview_child_container" data-session-recommendations-configuration-callback="recommendationConfigurationCallback"></div>
                        </div> -->
                        <div id="widgetPreview">
                            <div id="rec-widget"></div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</ccl-content-section>
